import React from "react";
import Hero from "../components/Hero";
import RatesBoard from "../components/RatesBoard";
import { Link } from "react-router-dom";
import { ArrowUpRight, Award, Banknote, Coins, RefreshCw, ShieldCheck, Target } from "lucide-react";

export default function Home() {
  return (
    <>
      <Hero />
      <div className="py-14 md:py-20" />
      <RatesBoard />

      {/* Why Akaydın */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-5 lg:sticky lg:top-32">
              <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-4">
                Neden Akaydın Döviz?
              </div>
              <h2 className="font-display text-4xl md:text-5xl font-bold text-slate-950 tracking-tighter leading-tight mb-6">
                Şeffaflık, hız ve güven üzerine kurulu bir hizmet anlayışı.
              </h2>
              <p className="text-slate-600 leading-relaxed mb-8">
                20 yılı aşkın süredir Yalova'da hizmet veren yetkili döviz büromuz, müşteri memnuniyetini ve kurumsal güveni ön planda tutar. Anlık piyasa verileriyle güncellenen kurlarımız ve şeffaf işlem politikamızla farkı hissedin.
              </p>
              <Link
                to="/hakkimizda"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-950 text-white text-sm font-semibold hover:bg-brand-gold transition-colors group"
              >
                Hakkımızda
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
              </Link>
            </div>

            <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
              {[
                { icon: <ShieldCheck className="w-6 h-6" />, t: "Güvenilir İşlem", d: "Yetkili döviz bürosu olarak yasal ve şeffaf işlemler." },
                { icon: <RefreshCw className="w-6 h-6" />, t: "Anlık Kurlar", d: "Canlı piyasa verileriyle dakikası dakikasına güncellenen fiyatlar." },
                { icon: <Banknote className="w-6 h-6" />, t: "Geniş Yelpaze", d: "20+ döviz türü ve çeşitli altın seçenekleri." },
                { icon: <Coins className="w-6 h-6" />, t: "Altın Hizmetleri", d: "Gram, çeyrek, yarım, tam ve cumhuriyet altını alım-satımı." },
                { icon: <Award className="w-6 h-6" />, t: "20+ Yıl Tecrübe", d: "Yalova'nın köklü ve güvenilir döviz markası." },
                { icon: <Target className="w-6 h-6" />, t: "Müşteri Odaklı", d: "Kurumsal ve bireysel müşterilere özel çözümler." },
              ].map((c, i) => (
                <div
                  key={i}
                  className="group relative p-7 rounded-2xl bg-slate-50 hover:bg-slate-950 hover:text-white border border-slate-200 hover:border-slate-950 transition-all duration-300 cursor-default"
                >
                  <div className="text-brand-gold mb-4">{c.icon}</div>
                  <h3 className="font-display font-semibold text-lg mb-2 text-slate-950 group-hover:text-white transition-colors">
                    {c.t}
                  </h3>
                  <p className="text-sm text-slate-600 group-hover:text-slate-300 leading-relaxed transition-colors">
                    {c.d}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA banner */}
      <section className="relative py-20 md:py-28 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1762279389020-eeeb69c25813"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/40" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <div className="max-w-2xl text-white">
            <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-4">
              Hızlı işlem
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter leading-[1] mb-6">
              Bugün dönüştürün, <br />
              <span className="text-brand-gold italic font-light">yarın kazanın.</span>
            </h2>
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              Yalova merkezimize uğrayın veya bizi arayın — uzmanlarımız size en uygun kurla hizmet sunsun.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="tel:+902268112950"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-brand-gold text-slate-950 text-sm font-bold hover:bg-white transition-colors"
                data-testid="cta-phone"
              >
                0226 811 29 50
              </a>
              <Link
                to="/iletisim"
                className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border border-white/30 text-white text-sm font-semibold hover:bg-white hover:text-slate-950 transition-colors"
              >
                Yol Tarifi Al
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
